<script setup lang="ts">
import { computed } from 'vue';
import type { FilterChip } from '@/types/browser';
import type { WorldInterface } from '@/types/worlds';
import { usePredicateStore } from '@/stores/predicate-store';
import { worldChips, removeWorldChip, SOURCE_CHIP_PREFIX } from '@/appdata/world-filters';
import FilterControl from '@/components/atoms/element-filters/FilterControl.vue';
import SourceFilter from '@/components/atoms/element-filters/SourceFilter.vue';

// Multi-select: matches elements published by ANY of the chosen sources. The predicate layer
// already mapped the slot to a uuid list (sourcesFilter / useElementPredicates), so widening the
// control needed no query change.
const props = defineProps<{ label: string; placeholder?: string }>();
const predicateStore = usePredicateStore();

const chips = computed<FilterChip[]>(() =>
  worldChips(predicateStore.sources as WorldInterface[], SOURCE_CHIP_PREFIX, props.label),
);

// Removes just the one its chip names, rather than clearing the filter.
const remove = (chip: FilterChip) => {
  predicateStore.sources = removeWorldChip(
    predicateStore.sources as WorldInterface[], chip, SOURCE_CHIP_PREFIX,
  );
};
</script>

<template>
  <FilterControl :label="label" :chips="chips" :multiple="true" @remove="remove">
    <SourceFilter v-model:sources="predicateStore.sources" :label="label" :placeholder="placeholder" />
  </FilterControl>
</template>
